import React from 'react'

const CallMadeMissedIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill={'red'}
    width="40"
    height="40"
    viewBox="0 0 24 24"
  >
    <defs>
      <path id="a" d="M24 24H0V0h24v24z" />
    </defs>
    <path d="M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z" />
  </svg>
  )

export default CallMadeMissedIcon



// WEBPACK FOOTER //
// ./src/components/assets/CallMadeMissedIcon.js